import { HttpParamsConfig } from "@shared/schemas/http-params-config";

function convertHttpParamsToQueryString(httpParamsConfig?: HttpParamsConfig): {
	[param: string]: string | number;
} {
	let params = {};
	if (httpParamsConfig) {
		const { fields, ...filters } = httpParamsConfig;
		if (fields) {
			fields.forEach((item) => {
				const fieldsParams = {
					[item.key]: item.value
				};
				params = { ...params, ...fieldsParams };
			});
		}
		params = { ...params, ...filters };
	}
	return params;
}

export { convertHttpParamsToQueryString };
